module.exports = __webpack_public_path__ + "media/camping.13554a70.mp4";